export type TenantDocumentMetadata = {
  id?: string;
  name: string;
  externalPropertyName?: string;
  metadataTypeEnum: MetadataEnum;
  selectValues?: string[];
  isDeleted?: boolean;
};

export enum MetadataEnum {
  StringValue = "StringValue",
  NumberValue = "NumberValue",
  BooleanValue = "BooleanValue",
  DateTimeValues = "DateTimeValues",
  SelectValues = "SelectValues",
}

export type WorkspaceDocumentMetadata = {
  id?: string;
  name: string;
  externalPropertyName?: string;
  metadata: DocumentMetadataType;
};

export type DocumentMetadataType = {
  stringValue?: string;
  numberValue?: number;
  booleanValue?: boolean;
  dateTimeValues?: Date[];
  selectValues?: string[];
};
